import React, { Fragment, useEffect } from "react";
import { withRouter } from "react-router-dom";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import { Box, IconButton, Stack, TableContainer, TextField } from "@mui/material";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableFooter from "@mui/material/TableFooter";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { makeStyles } from "@material-ui/core/styles";
import styles from "./BuscarAsociado.module.css";
import Autocomplete from "@mui/material/Autocomplete";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Typography from '@mui/material/Typography';
import { faEye, faFile } from "@fortawesome/free-solid-svg-icons";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { v4 as uuidv4 } from "uuid";
import { obtenerDatosPredioByIdCliente, obtenerDatosPredioByNoSocio, } from "../../../redux/DucksUsuarioAgricola/DatosPredioDucks";
import { useDispatch, useSelector } from "react-redux";
import { datMagueyH, obtenerAllDatosMagueyHistorico } from "../../../redux/DucksUsuarioAgricola/DatosMagueyHistoricoDucks";
import {
  obtenerGuiaByIdentificador,
} from "../../../redux/DucksUsuarioAgricola/GuiaMagueyDucks";

function BuscarAsociado(props) {

  const dispatch = useDispatch();

  const dataValues = props.dataValues;
  const dataTableHead = props.dataTableHead;

  //let dataPredio = useSelector((store) => store.DatosPredioApi?.data?.data);
  //let dataIdentificador = useSelector((store) => store.GuiaMagueyApi?.data?.data);


  const [guias, setGuias] = React.useState([]);
  const handleCloseGuia = () => setOpenG(false);
  const [openG, setOpenG] = React.useState(false);
  const [asociado, setAsociado] = React.useState({
    numerosocio: null,
    idcliente: null,
    personafisica: null,
    personamoral: null,
    nombrerazonsocial: null,
    fechasolicitud: null,
    rfc: null,
    telefono: null,
    correoelectronico: null,
    nombrerepresentantelegal: null,
    telefonorepresentante: null,
    correoelectronicorepresentante: null,
    empresacertificadora: null,
    idtipocliente: null,
    idlogin: null,
    idcartera: null,
  });



  const [dataMagueyH, setDataMagueyH] = React.useState({
    iddatosmaguey: null,
    numeroplantas: null,
    sistemaplantacion: null,
    distanciaplantas: null,
    distanciasurcos: null,
    edad: null,
    iddatospredio: null,
    idcatalogomaguey: null,
    usuariocambio: null,
    fechacreacion: null,
  });

  const [modal, setModal] = React.useState(false);
  const abrirCerrarModal = (item) => {
    setAsociado(item);
    setModal(!modal);
  };

  const boxDefault = {
    height: 100,
    boder: "1px solid black",
    padding: 2,
    minWidth: 550,
    m: 1

  }

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 800,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };


  const handleOpenG = (guias) => {
    setGuias(guias)
    setOpenG(true);
  }

  const [noGuia, setNoGuia] = React.useState("");

  const [openModal, setOpenModal] = React.useState(false);

  const descriptionElementRef = React.useRef(null);
  const [openModalPredio, setOpenModalPredio] = React.useState(false);

  const descriptionElementPredioRef = React.useRef(null);

  const handleClickOpen = (item) => {
    setOpenModal(true);
    setAsociado(item);
  };

  const handleChangePanel = async () => {
    await dispatch(obtenerAllDatosMagueyHistorico(predio.iddatospredio))
    props.history.push("/PanelConsultaMovimiento", { data: predio.iddatospredio })
  };






  const handleClose = () => {
    setOpenModal(false);
    setTelefonoPersona('')
    setCorreoPersona('')
  };

  const handleClickPredioOpen = (item) => {
    setOpenModalPredio(true);
    setPredio(item);
  };

  const handleAceptarPredio = () => {
    setOpenModalPredio(false);
  };

  const handleClosePredio = () => {
    setOpenModalPredio(false);
  };



  /*  */
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [search, setSearch] = React.useState("");
  const [dataTable, setDataTable] = React.useState(dataValues);
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - dataTable.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const filterValues = (valueSearch) => {
    const dataFilter = dataTable.filter((item) => {
      if (
        item.nombrerazonsocial
          .toString()
          .toLowerCase()
          .includes(valueSearch.toString().toLowerCase()) ||
        item.idcliente
          .toString()
          .toLowerCase()
          .includes(valueSearch.toString().toLowerCase()) ||
        item.numerosocio
          .toString()
          .toLowerCase()
          .includes(valueSearch.toString().toLowerCase())

      ) {
        return item;
      }
    });
    setDataTable(dataFilter);
  };

  React.useEffect(() => {
    if (!search.trim() || !search) {
      setDataTable(dataValues);
      return;
    }
    filterValues(search);
  }, [search]);

  React.useEffect(() => {
      setDataTable(props?.dataValues);
  }, [props?.dataValues]);

  React.useEffect(() => {
    // dispatch(obtenerRegistrosPredios());
  }, [])


  React.useEffect(() => {

    if (asociado.idcliente !== null) {
      dispatch(obtenerDatosPredioByIdCliente(asociado.idcliente));
    }
  }, [asociado])





  const [predio, setPredio] = React.useState({
    id: null,
    num_guia: null,
    superficieH: null,
    nombre_predio: null,
    longitud: null,
    nombre_cliente: null,
    RFC: null,
    estado: null,
    representanteLegal: null,
    razonSocial: null,
    latitud: null,
    localidad: null,
    municipio: null,
    calle: null,
    noExt: null,
    cp: null,
    correo: null,
    edad: null,
    existencia: null,
  });

  const bodyPredio = (
    <>
      <div className="bg-light rounded  ">
        <h3 className="text-center">Datos Predio</h3>
        <div className="row">
          <div className="col-6">
            <label className="form-label">Num Predio: </label>
            <TextField
              variant="outlined"
              sx={{
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
              }}
              size="small"
              style={{ background: "white" }}
              fullWidth
              value={
                predio !== null && predio.iddatospredio !== null
                  ? predio.iddatospredio
                  : ""
              }
            />

          </div>

          <div className="col-6">
            <label className="form-label">Nombre Predio:</label>
            <TextField
              variant="outlined"
              sx={{
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
              }}
              size="small"
              style={{ background: "white" }}
              fullWidth
              value={
                predio !== null && predio.nombrepredio !== null
                  ? predio.nombrepredio
                  : ""
              }
            />
          </div>

          <div className="col-6">
            <label className="form-label">Longitud:</label>
            <TextField
              variant="outlined"
              sx={{
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
              }}
              size="small"
              style={{ background: "white" }}
              fullWidth
              value={
                predio !== null && predio.longitudoeste !== null
                  ? predio.longitudoeste
                  : ""
              }
            />
          </div>

          <div className="col-6">
            <label className="form-label">Latitud:</label>
            <TextField
              variant="outlined"
              sx={{
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
              }}
              size="small"
              style={{ background: "white" }}
              fullWidth
              value={
                predio !== null && predio.latitudnorte !== null ? predio.latitudnorte : ""
              }
            />
          </div>
          <div className="col-6">
            <label className="form-label">Localidad:</label>
            <TextField
              variant="outlined"
              sx={{
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
              }}
              size="small"
              style={{ background: "white" }}
              fullWidth
              value={
                predio !== null && predio.localidad !== null
                  ? predio.localidad
                  : ""
              }
            />
          </div>

          <div className="col-6">
            <label className="form-label">Municipio:</label>
            <TextField
              variant="outlined"
              sx={{
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
              }}
              size="small"
              style={{ background: "white" }}
              fullWidth
              value={
                predio !== null && predio.municipio !== null
                  ? predio.municipio
                  : ""
              }
            />
          </div>

          <div className="col-12 pt-4">
            <h4 className="text-center">Maguey en Predio</h4>
            <Paper sx={{ width: "100%" }}>
              <TableContainer sx={{ maxHeight: 700 }}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Numero de plantas</TableCell>
                      <TableCell>Sistema de plantacion </TableCell>
                      <TableCell>Distancia plantas</TableCell>
                      <TableCell>Distancia Surcos</TableCell>
                      <TableCell>Edad</TableCell>
                      <TableCell>Especie</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {predio !== null && predio.datosmaguey ? (
                      predio.datosmaguey.map((item, i) => (
                        <TableRow
                          key={item.id}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                        >
                          <TableCell>{item.numeroplantas}</TableCell>
                          <TableCell>{item.sistemaplantacion}</TableCell>
                          <TableCell>{item.distanciaplantas}</TableCell>
                          <TableCell>{item.distanciasurcos}</TableCell>
                          <TableCell>{item.edad}</TableCell>
                          <TableCell>{item.catalogomaguey.nombrecomun}</TableCell>
                        </TableRow>

                      ))
                    ) : (
                      <></>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>


          </div>


        </div>

      </div>

    </>
  );
  let [persona, setPersona] = React.useState('')
  let [correoPersona, setCorreoPersona] = React.useState('')
  let [telefonoPersona, setTelefonoPersona] = React.useState('')
  const seleccionPersona = (value) => {
    if (value == '') {
      setPersona('')
      setCorreoPersona('')
      setTelefonoPersona('')
    } else {
      const filtro = asociado?.representantesautorizadoscliente.filter(anexo => anexo.idrepresentantesautorizados == value)
      setPersona(filtro?.[0]?.personaautoriazadaparatramites)
      setCorreoPersona(filtro?.[0]?.correoelectronicopersona)
      setTelefonoPersona(filtro?.[0]?.telefonopersona)
    }
  }
  const body = (
    <>
      <div className="rounded">
        <h3 className="text-center">Datos del Asociado</h3>
        <div className="row">
          <h5 className="text-center" >Información Asociado:</h5>
          <hr />
          <div className="col-6">
            <label className="form-label">Número de Cliente: </label>
            <TextField
              variant="outlined"
              sx={{
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
              }}
              size="small"
              style={{ background: "white" }}
              fullWidth
              value={
                asociado !== null && asociado.numerosocio !== null
                  ? asociado.numerosocio
                  : ""
              }
            />
          </div>

          <div className="col-6">
            <label className="form-label">Nombre o Razón Social</label>
            <TextField
              variant="outlined"
              sx={{
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
              }}
              size="small"
              style={{ background: "white" }}
              fullWidth
              value={
                asociado !== null && asociado.nombrerazonsocial !== null
                  ? asociado.nombrerazonsocial.toUpperCase()
                  : ""
              }
            />
          </div>
          <div className="col-6">
            <label className="form-label">RFC:</label>
            <TextField
              variant="outlined"
              sx={{
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
              }}
              size="small"
              style={{ background: "white" }}
              fullWidth
              value={
                asociado !== null && asociado.rfc !== null ? asociado.rfc : ""
              }
            />
          </div>

          <div className="col-6">
            <label className="form-label">Teléfono:</label>
            <TextField
              variant="outlined"
              sx={{
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
              }}
              size="small"
              style={{ background: "white" }}
              fullWidth
              value={
                asociado !== null && asociado.telefono !== null
                  ? asociado.telefono
                  : ""
              }
            />
          </div>
          <div className="col-6">
            <label className="form-label">Representante Legal:</label>
            <TextField
              variant="outlined"
              sx={{
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
              }}
              size="small"
              style={{ background: "white" }}
              fullWidth
              value={
                asociado !== null && asociado.nombrerepresentantelegal !== null
                  ? asociado.nombrerepresentantelegal.toUpperCase()
                  : ""
              }
            />
          </div>
          <div className="col-6">
            <label className="form-label">Correo Electrónico:</label>
            <TextField
              variant="outlined"
              sx={{
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
              }}
              size="small"
              style={{ background: "white" }}
              fullWidth
              value={
                asociado !== null && asociado.correoelectronico !== null
                  ? asociado.correoelectronico
                  : ""
              }
            />
          </div>
          <div className="col-6">
            <div className="form-floating mb-1 mt-3">
              <select value={persona} onChange={e => seleccionPersona(e.target.value)}
                className={`form-select form-select-sm `} >
                <option value="" >Personas Autorizadas</option>
                {asociado !== null && asociado?.representantesautorizadoscliente !== null
                  ? asociado?.representantesautorizadoscliente?.map((item, i) =>
                    <option value={item.idrepresentantesautorizados} >{item.personaautoriazadaparatramites}</option>
                  )
                  : ''}
              </select>
              <label>Persona Autorizada</label>
            </div>

          </div>
          <div className="col-6">
            <label className="form-label">Teléfono Persona Autorizada:</label>
            <TextField
              variant="outlined"
              sx={{ "& legend": { display: "none" }, "& fieldset": { top: 0 }, }}
              size="small" style={{ background: "white" }} fullWidth value={telefonoPersona}
            />
          </div>
          <div className="col-6">
            <label className="form-label">Correo electrónico Persona Autorizada:</label>
            <TextField
              variant="outlined"
              sx={{ "& legend": { display: "none" }, "& fieldset": { top: 0 }, }}
              size="small" style={{ background: "white" }} fullWidth value={correoPersona}
            />
          </div>
        </div>
      </div>
    </>
  );

  return (
    <Fragment>
      <br />
      <div className="container ">
        <div className="row">
          <div className="col-12">
            <TextField
              id="a"
              fullWidth
              value={search}
              label="Buscar"
              onChange={(e) => {
                setSearch(e.target.value);
              }}
              size="small"
            />
          </div>
        </div>
      </div>

      <div className="container ">
        <div className="row">
          <div className="col-12">
            <Paper sx={{ width: "100%" }}>
              <TableContainer sx={{ maxHeight: 600 }}>
                <Table>
                  <TableHead>
                    <TableRow>
                      {dataTableHead.map((item, i) => (
                        <TableCell key={i}>{item}</TableCell>
                      ))}
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {(rowsPerPage > 0
                      ? dataTable?.slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      : dataTable
                    )?.map((row, i) => (
                      <TableRow key={i}>
                        {/*<TableCell component="th" scope="row">
                          {row.idcliente}
                        </TableCell>*/}
                        <TableCell>{row.numerosocio}</TableCell>

                        <TableCell>{row.nombrerazonsocial.toUpperCase()}</TableCell>
                        {/*          <TableCell>{row.nombre_predio}</TableCell> */}
                        <TableCell>
                          <button type="button" className="badge btn-primary text-light" onClick={() => handleClickOpen(row)} >
                            <FontAwesomeIcon icon={faEye} /> <br /> Ver Información </button>

                        </TableCell>
                      </TableRow>
                    ))}

                    {emptyRows > 0 && (
                      <TableRow style={{ height: 53 * emptyRows }}>
                        <TableCell colSpan={6} />
                      </TableRow>
                    )}
                  </TableBody>
                  <TableFooter>
                    <TableRow>
                      <TablePagination
                        rowsPerPageOptions={[
                          5,
                          10,
                          25,
                          { label: "Todos", value: -1 },
                        ]}
                        labelDisplayedRows={({ from, to, count }) =>
                          ` ${from}-${to} de ${count}`
                        }
                        labelRowsPerPage={<span>Registros por página:</span>}
                        count={dataTable.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}

                        onRowsPerPageChange={handleChangeRowsPerPage}
                      />
                    </TableRow>
                  </TableFooter>
                </Table>
              </TableContainer>
            </Paper>
            <Dialog open={openModal} scroll="body" maxWidth={"md"}>
              <DialogContent dividers={true}>
                <DialogContentText
                  ref={descriptionElementRef}
                  tabIndex={-1}
                ></DialogContentText>
                {body}
              </DialogContent>
              <DialogActions>
                <Button variant="secondary" onClick={handleClose}>Cerrar</Button>
              </DialogActions>
            </Dialog>
          </div>
        </div>
      </div>
    </Fragment>


  );
}

export default withRouter(BuscarAsociado);
